import React from 'react';
import { Button, Modal, Toast, Badge } from 'antd-mobile';
import {post} from '../../utils/request';
import { href } from '../../utils/util';

import { wxfx } from '../../utils/wxfx.js';

import changtu from '../image/changtu.png';

import './index.less';


class MarketingOnlineActivity extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            source: '',
        };

        wxfx({
            title: '福利来袭，租车有礼',
            imgUrl: 'https://image.tf56.com/dfs/group1/M00/4E/78/CiFCK1-GUPGAYad7AAFYlNKimoQ501.png',
            desc: '送货市区进不去？试试新能源吧！',
        })
        setTimeout(()=>{
            if(window.location.hash.split('#')[1].indexOf('?') > -1 ){
                const search = window.location.hash.split('#')[1].split('?')[1];
                const source = search.split('=')[1];
                if(source == 1){
                    window._czc.push(['_setCustomVar', '来源', '业务人员渠道', 0]);
                }else if(source == 2){
                    window._czc.push(['_setCustomVar', '来源', '短信渠道', 0]);
                }else if(source == 3){
                    window._czc.push(['_setCustomVar', '来源', 'APP渠道', 0]);
                }
            }
        },200);
    }
    
    render() {
        return (
            <div className="MarketingOnlineActivityBox">
                {
                    // <img style={{ width: '100%' }} src={ changtu  } />
                    <div style={{ width: '100%', height: 'calc(100vw * 3.43466)', background: 'url('+changtu+') no-repeat 0 0', backgroundSize: 'cover' }}></div>
                }
                
                <div style={{ width: '100%', height: '50px' }}></div>
                <div style={{ fontSize: 18, color: '#333', width: '100%', lineHeight: '60px', textAlign: 'center', position: 'fixed', left: 0, bottom: 0, background: '#F8FC02' }} onClick={()=>{
                        href(`/MarketingOnlineIndex`);
                    }}>
                    马上选车
                </div>
            </div>
        );
    }
}

export default MarketingOnlineActivity;


// WEBPACK FOOTER //
// ./src/marketingOnline/activity/index.js